import { c as _c } from "react/compiler-runtime";
import { useTheme } from '@wrksz/themes/client';
import type { CSSProperties } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import oneDarkImport from 'react-syntax-highlighter/dist/cjs/styles/prism/one-dark';
import oneLightImport from 'react-syntax-highlighter/dist/cjs/styles/prism/one-light';
type PrismStyle = Record<string, CSSProperties>;
const oneLight = oneLightImport as PrismStyle;
const oneDark = oneDarkImport as PrismStyle;
export const CodeBlock: React.FC<{
  className?: string;
  children: string;
}> = t0 => {
  const $ = _c(14);
  const {
    className,
    children
  } = t0;
  const classNameString = className ?? "";
  let t1;
  if ($[0] !== classNameString) {
    t1 = classNameString.startsWith("language-") ? classNameString.slice(9) : "text";
    $[0] = classNameString;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const language = t1;
  const t2 = children ?? "";
  let t3;
  if ($[2] !== t2) {
    t3 = t2.trimEnd();
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const code = t3;
  const {
    resolvedTheme
  } = useTheme();
  const isDark = resolvedTheme === "dark";
  const t4 = isDark ? oneDark : oneLight;
  const t5 = isDark ? "#020617" : "#f1f5f9";
  let t6;
  if ($[4] !== t5) {
    t6 = {
      backgroundColor: t5,
      padding: "0.5rem",
      overflowX: "hidden"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = isDark ? "#020617" : "#f1f5f9";
  let t8;
  if ($[6] !== t7) {
    t8 = {
      style: {
        backgroundColor: t7,
        whiteSpace: "pre-wrap"
      }
    };
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== code || $[9] !== language || $[10] !== t4 || $[11] !== t6 || $[12] !== t8) {
    t9 = <div className="code-block"><SyntaxHighlighter language={language} style={t4} wrapLines={true} showLineNumbers={true} customStyle={t6} lineProps={t8}>{code}</SyntaxHighlighter></div>;
    $[8] = code;
    $[9] = language;
    $[10] = t4;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};